import React, { FC, memo, MouseEventHandler, useCallback } from 'react'

import { ButtonTransport } from '@common/transports/deprecated-home-page-transport'
import { StyledSidebarItem } from './sidebar-item-styles'
import { AnalyticsService } from '@src/services'

interface Props {
    onClick: MouseEventHandler<HTMLElement>
    item: ButtonTransport
    eventCategory: string
}

const SidebarItem: FC<Props> = ({ onClick, item, eventCategory }) => {
    const _handleSidebarItemClick = useCallback(
        e => {
            if (item.eventLabel) {
                AnalyticsService.trackClickEvent(eventCategory, item.eventLabel)
            }
            if (onClick) {
                onClick(e)
            }
        },
        [onClick, item, eventCategory],
    )

    return (
        <StyledSidebarItem onClick={_handleSidebarItemClick} href={item.url}>
            {item.text}
        </StyledSidebarItem>
    )
}

export default memo(SidebarItem)
